import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { ICreateComplexModalState } from './interfaces';
import { postRequest } from 'api/requests';
import { IComplex } from 'interfaces/main';
import { defaultComplex } from 'consts/default';

// Открытие окна с новым ЖК
export const openCreateComplexModal = createAction(
  'createComplexModal/openCreateComplexModal',
  (organizationId: number | null) => ({
    payload: { organizationId },
  }),
);

// Закрытие окна с новой организацией
export const closeModal = createAction('createComplexModal/closeModal');

// Добавление новой группы
export const createComplex = createAsyncThunk(
  'createComplexModal/createComplex',
  async (newComplex: IComplex, { rejectWithValue }) => {
    try {
      const response = await postRequest('complex', newComplex, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState: ICreateComplexModalState = {
  data: defaultComplex,
  isLoading: false,
  isVisible: false,
};

const createComplexModalSlice = createSlice({
  name: 'createComplexModal',
  initialState,
  reducers: {
    openCreateComplexModal: (state, { payload }) => ({
      ...initialState,
      isVisible: true,
      data: {
        ...state.data,
        organizationId: payload.organizationId,
      }
    }),
    closeModal: () => initialState,
    changeField: (state, { payload }) => ({
      ...state,
      data: {
        ...state.data,
        [payload.field]: payload.value,
      },
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(createComplex.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(createComplex.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(createComplex.fulfilled, () => initialState);
  },
});

// Селекторы
export const CreateComplexModalSelector = (
  state: RootState,
): ICreateComplexModalState => state.createComplexModal;

export const CreateComplexModalLoadingSelector = createSelector(
  CreateComplexModalSelector,
  ({ isLoading }) => isLoading,
);

export const CreateComplexModalVisibleSelector = createSelector(
  CreateComplexModalSelector,
  ({ isVisible }) => isVisible,
);

export const CreateComplexModalDataSelector = createSelector(
  CreateComplexModalSelector,
  ({ data }) => data,
);

export default createComplexModalSlice.reducer;
